/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
import { AuthActionsTypes } from './Auth.actions';
import { defaultAuthState } from './Auth.state';
import { combineReducers } from 'redux';
import update from 'immutability-helper';
import { Base64 } from 'js-base64';
import { Status } from '../status/Status';
var isLoggedIn = function (state, action) {
    if (state === undefined) {
        return defaultAuthState.isLoggedIn;
    }
    switch (action.type) {
        case AuthActionsTypes.AUTH_SUCCESS: {
            return update(state, { $set: action.payload.response === 202 });
        }
        case AuthActionsTypes.AUTH_RESET: {
            return update(state, { $set: false });
        }
        case AuthActionsTypes.LOGOUT: {
            return update(state, { $set: false });
        }
        default:
            return state;
    }
};
var username = function (state, action) {
    if (state === undefined) {
        return defaultAuthState.username;
    }
    switch (action.type) {
        case AuthActionsTypes.AUTH_REQUEST: {
            return update(state, { $set: action.payload.username });
        }
        case AuthActionsTypes.AUTH_SUCCESS: {
            return update(state, { $set: state });
        }
        case AuthActionsTypes.AUTH_RESET: {
            return update(state, { $set: state });
        }
        case AuthActionsTypes.LOGOUT: {
            return update(state, { $set: '' });
        }
        default:
            return state;
    }
};
var token = function (state, action) {
    if (state === undefined) {
        return defaultAuthState.token;
    }
    switch (action.type) {
        case AuthActionsTypes.AUTH_REQUEST: {
            var token_1 = "".concat(action.payload.username, ":").concat(action.payload.password);
            var encodedToken = Base64.encode(token_1);
            return update(state, { $set: encodedToken });
        }
        case AuthActionsTypes.AUTH_SUCCESS: {
            return update(state, { $set: state });
        }
        case AuthActionsTypes.AUTH_RESET: {
            return update(state, { $set: state });
        }
        case AuthActionsTypes.LOGOUT: {
            return update(state, { $set: '' });
        }
        default:
            return state;
    }
};
var errorMessage = function (state, action) {
    if (state === undefined) {
        return defaultAuthState.errorMessage;
    }
    switch (action.type) {
        case AuthActionsTypes.AUTH_SUCCESS:
            return update(state, { $set: null });
        case AuthActionsTypes.AUTH_FAILURE:
            return update(state, { $set: action.payload });
        case AuthActionsTypes.AUTH_RESET:
            return update(state, { $set: null });
        case AuthActionsTypes.LOGOUT:
            return update(state, { $set: null });
        default:
            return state;
    }
};
var status = function (state, action) {
    if (state === undefined) {
        return defaultAuthState.status;
    }
    switch (action.type) {
        case AuthActionsTypes.AUTH_REQUEST: {
            return update(state, { $set: Status.BUSY });
        }
        case AuthActionsTypes.AUTH_SUCCESS: {
            return update(state, { $set: Status.SUCCESS });
        }
        case AuthActionsTypes.AUTH_FAILURE: {
            return update(state, { $set: Status.ERROR });
        }
        case AuthActionsTypes.AUTH_RESET: {
            return update(state, { $set: Status.READY });
        }
        case AuthActionsTypes.LOGOUT: {
            return update(state, { $set: Status.READY });
        }
        default: {
            return state;
        }
    }
};
export var authReducer = combineReducers({
    isLoggedIn: isLoggedIn,
    username: username,
    token: token,
    status: status,
    errorMessage: errorMessage,
});
